import { render, staticRenderFns } from "./CompleteUserData.vue?vue&type=template&id=3459554a"
import script from "./CompleteUserData.vue?vue&type=script&lang=js"
export * from "./CompleteUserData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports